import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PopinService} from '../services/popin.service';
import {Data} from '../providers/data.provider';
import {PopinTwoComponent} from '../popin-two/popin-two.component';
import {NotificationService} from '../services/notification.service';
import {PopinOneComponent} from '../popin-one/popin-one.component';
import {PopinVisit} from '../models/popinvisit.model';
import {MailSent} from '../models/mailsent.model';
import {DatasaveService} from '../services/datasave.service';

@Component({
  selector: 'app-popin-four',
  templateUrl: './popin-four.component.html',
  styleUrls: ['./popin-four.component.scss']
})
export class PopinFourComponent implements OnInit {

  public companyName: string;
  public productId: string;
  public helpType: string;
  public supportManager: any;
  public salesManager: any;
  public adminManager: any;
  public dest: any;
  public exped: any;
  public popinvisit: PopinVisit;
  public mailsent: MailSent;
  public mailtype: string;
  public visittype: string;

  constructor(private popinService: PopinService,
              private notifService: NotificationService,
              private datasaveService: DatasaveService,
              private router: Router,
              private route: ActivatedRoute,
              private data: Data) { }

  ngOnInit(): void {
    this.adminManager = this.data.storage.companyAccount.adminManager;
    this.productId = this.route.snapshot.params['product'];
    this.helpType = this.route.snapshot.params['helpType'];

    for (const product of PopinTwoComponent.companyProducts) {
      if (product._id === this.productId) {
        this.supportManager = product.supportManager;
        this.salesManager = product.salesManager;
        this.exped = {
          'company': PopinOneComponent.customer,
          'helpType': this.helpType,
          'product': product,
          'website': this.data.storage.website
        };
      }
    }

    switch (this.helpType) {
      case 'technique':
        this.mailtype = PopinOneComponent.MAILTYPE_SUPPORTTECHNIQUE;
        this.visittype = PopinOneComponent.VISITTYPE_SUPPORTTECHNIQUE;
        this.dest = this.supportManager;
        break;
      case 'commerciale':
        this.mailtype = PopinOneComponent.MAILTYPE_CONTACTCOMMERCIAL;
        this.visittype = PopinOneComponent.VISITTYPE_CONTACTCOMMERCIAL;
        this.dest = this.salesManager;
        break;
      default:
        this.mailtype = PopinOneComponent.MAILTYPE_CONTACTADMINISTRATIF;
        this.visittype = PopinOneComponent.VISITTYPE_CONTACTADMINISTRATIF;
        this.dest = this.adminManager;
        break;
    }

    this.mailsent = {
      popin: PopinOneComponent.popinId,
      mailType: this.mailtype,
      recipient: this.dest['_id']
    };

    this.popinvisit = {
      popin: PopinOneComponent.popinId,
      companyIdentifier: PopinOneComponent.customer['SIREN'],
      isCustomer: PopinOneComponent.isCustomer,
      visitType: this.visittype,
      product: this.productId,
      visitRandomId: PopinOneComponent.visitRandomId,
      visitorContent: null
    };

    this.notifService.sendClientNotificationToManager(this.dest, this.exped)
      .then(() => {
        this.datasaveService.saveMailData(this.mailsent);
        this.datasaveService.saveVisitData(this.popinvisit);
        setTimeout(() => {
          this.sendEventToParent();
        }, 3000);
      })
      .catch(error => {
        console.log(error);
      });
  }

  sendEventToParent() {
    window.parent.postMessage('exit', PopinOneComponent.uri);
  }

}
